/**
* @description: 设备模板管理
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch">
                <template #btns>
                <el-button
                    type="primary"
                    icon="Plus"
                    @click="$refs['addTemplate'].open()"
                    >{{ t('common.add') }}</el-button
                >
                </template>
            </hc-search>
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
                 :maxPage="maxPage"
                @pageChange="pageChange" @limitChange="limitChange">
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="$refs['addTemplate'].open(scope.row)">{{ t('common.edit') }}</el-button>
                        <el-button size="small" class="opBtn" type="primary" link
                            @click="toMaintenance(scope.row)">{{ t('deviceTemplate.maintenancePlan') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>
        <!-- 新增 -->
        <EditTemplate ref="addTemplate" :title="state.title" :statusOptions="statusOptions" @refresh="getSearch(searchData)" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, onActivated, toRaw } from "vue";
import { useRouter } from 'vue-router';
import EditTemplate from "./components/templateAdd.vue";

import { pageListApi, saveApi } from "@/api/system/template";
import { listToMap } from "@/utils/utils";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applySearchLabels, applyColumnLabels, applyOptionLabels } from "@/utils/listPageI18n.js";
const myElementRef = ref();
const searchBox = ref();
const addTemplate = ref();
const router = useRouter();


let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const statusOptions = reactive([
    { label: "", value: 1 },
    { label: "", value: 0 }
])

const applyLabels = () => {
    applySearchLabels(searchData, {
        keywords: { labelKey: 'deviceTemplate.keyword' },
    });
    applyColumnLabels(state.column, {
        id: 'deviceTemplate.templateId',
        title: 'deviceTemplate.templateName',
        name: 'deviceTemplate.templateIntro',
        created_at: 'taskSubmit.createdAt',
        updated_at: 'taskSubmit.updatedAt',
        operation: 'table.operation',
    });
    applyOptionLabels(statusOptions, {
        1: 'status.enabled',
        0: 'status.disabled',
    });
};
const { t } = usePageI18n(applyLabels);

const searchData = reactive([
    {
        label: "关键字",
        type: "input",
        value: "",
        field: 'keywords'
    },
]);


const state = reactive({
    title: "",
    column: [
        {
            prop: "id",
            show: false,
            label: "模板ID",
        },
        {
            // prop: "id",
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "title",
            show: true,
            label: "模板名称",
        },
        {
            prop: "name",
            show: true,
            label: "模版介绍",
        },
        // {
        //     prop: "model",
        //     show: true,
        //     label: "机型",
        // },
        {
            prop: "created_at",
            show: true,
            label: "创建时间",
        },
        {
            prop: "updated_at",
            show: true,
            label: "更新时间",
        },
        {
            prop: "operation",
            show: true,
            label: "操作",
        },
    ],
    offsetHeight: 0,
    tableHeader: [],
    tableData: []
});

const init = () => {
    getSearch(searchData)
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}

const toMaintenance = (row) => {
    router.push({
        path: '/maintenance',
        query: { id: toRaw(row).id }
    });
}

onMounted(() => {
    try {
        applyLabels();
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

// 查询过来的数据
const getSearch = (params) => {
    const requestParams = JSON.stringify({
        page: page.value,
        limit: limit.value,
        ...listToMap(params, { value: 'value', key: 'field' })
    })
    pageListApi(requestParams).then(res => {
              maxPage.value = res?.maxPage ?? 0;
      state.tableData = res?.data ?? []
    })
};

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    // margin: 0 !important;
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
